import React from 'react'
import { useTranslation } from 'react-i18next' // i18n failed in storybook, therefore import react-i18next instead
import styled from 'styled-components'
import tw from 'twin.macro'
import { ImageAddIcon } from '@components/Icons'
import Button, { ButtonSize, ButtonVariant } from '@components/DesignSystem/Button'

function EmptyCard(props) {
  const { selectedFiles, maxImageCount } = props
  const { t } = useTranslation('imageInput')
  return (
    <StyledEmptyCard>
      <Content>
        <Button size={ButtonSize.medium} variant={ButtonVariant.primary}>
          <ImageAddIcon />
          <span>{t(['uploadImages', '上傳圖片'])}</span>
        </Button>
        <Hint>
          <p>{t(['orDragToAddImages', '或拖曳新增圖片'])}</p>
          <p>{t(['suggestedSize', '建議尺寸 1560x820 像素'])}</p>
        </Hint>
        {/* <Remain>
          {selectedFiles.length === 0
            ? t(['uploadMaxLimit', `上限 ${maxImageCount} 張`], { max: maxImageCount })
            : t(
                ['availableUploadCounts', `可以再上傳 ${maxImageCount - selectedFiles.length} 張`],
                { remain: maxImageCount - selectedFiles.length },
              )}
        </Remain> */}
      </Content>
    </StyledEmptyCard>
  )
}
export default EmptyCard

const Content = styled.div`
  display: none;
`
const StyledEmptyCard = styled.div`
  ${tw`flex items-center justify-center flex-shrink-0`}
  ${tw`absolute top-0 left-0 w-full h-full`}
  ${tw`bg-gray-30`}
  &:nth-child(1) ${Content} {
    ${tw`flex items-center justify-center flex-col`}
  }
`

const Hint = styled.div`
  ${tw`block`}
  ${tw`text-center`}
  ${tw`text-gray-400`}
  height: 40px;
  font-size: 14px;
  margin-top: 16px;
`
// const Remain = styled.div`
//   ${tw`block`}
//   ${tw`text-center`}
//   ${tw`text-gray-200`}
//   font-size: 12px;
//   margin-top: 4px;
// `
